export default __webpack_public_path__ + "static/media/ranking-level-dropped-step5.c206b6a0.png";